"use client";
import { usePathname } from "next/navigation";
import {
  Navigation,
  INavigationItem,
  setActiveNavigation,
} from "@/components/common/header/nav-bars/Navigation";

export const DetailPageNavigation = (props: {
  navigationItems: INavigationItem[];
  disableClicks?: boolean;
}) => {
  const pathName = usePathname();

  const navItemsWithActiveState = setActiveNavigation(
    props.navigationItems,
    pathName
  );
  return (
    <Navigation
      items={navItemsWithActiveState}
      className="border-neutral-medium bg-neutral-lighter text-14 text-input-text sm:text-16 border-b font-sans"
      sideElement={<div id="subnav-side-element" className="flex h-full" />}
      disableClicks={props?.disableClicks} //temp @DCATZVA?
      isSubNav={true}
    />
  );
};
